import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const variants = {
  fadeUp: {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 }
  },
  fadeLeft: {
    hidden: { opacity: 0, x: -40 },
    visible: { opacity: 1, x: 0 }
  },
  fadeRight: {
    hidden: { opacity: 0, x: 40 },
    visible: { opacity: 1, x: 0 }
  },
  scaleIn: {
    hidden: { opacity: 0, scale: 0.85 },
    visible: { opacity: 1, scale: 1 }
  },
  fadeIn: {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  }
};

const AnimatedSection = ({
  children,
  variant = 'fadeUp',
  stagger = false,
  delay = 0,
  duration = 0.6,
  className = '',
  style = {},
  threshold = 0.15,
  once = true
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once, amount: threshold });
  const selectedVariant = variants[variant] || variants.fadeUp;
  const transition = { duration, delay, ease: [0.4, 0, 0.2, 1] };

  if (stagger) {
    return (
      <motion.div
        ref={ref}
        className={className}
        style={style}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
      >
        {React.Children.map(children, (child, i) => (
          <motion.div
            key={i}
            variants={selectedVariant}
            initial="hidden"
            animate={isInView ? 'visible' : 'hidden'}
            transition={{ ...transition, delay: delay + i * 0.12 }}
          >
            {child}
          </motion.div>
        ))}
      </motion.div>
    );
  }

  return (
    <motion.div
      ref={ref}
      className={className}
      style={style}
      variants={selectedVariant}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedSection;
